//libraries
import React, { useEffect, useState, useRef, } from 'react';
import { Row, Col, Navbar, Container, Nav, Image, Dropdown, NavDropdown, Button, Tab, Modal, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useParams, useHistory } from 'react-router-dom';

//components
import FooterMenuAccess from '../../components/functionalComponents/DashboardLayout/FooterMenu';
import NavbarMarket from '../../components/functionalComponents/baseLayout/navbar';
import favicon from '../../assets/img/Favicon_AVAP_Marketplace.png'

//assets
import { faStar, faPhone, faEnvelope, faGlobe } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin, faRedditSquare, } from '@fortawesome/free-brands-svg-icons';

import icon_descarga from '../../assets/img/ui_icons/icono-descarga.svg'
import icon_mail from '../../assets/img/ui_icons/icono-mail-red.svg'
import icon_web from '../../assets/img/ui_icons/icon-web.svg'
import icon_location from '../../assets/img/ui_icons/icono-country.svg'

import succesImage from '../../assets/img/ilustraciones/Ilustración_añadidoExito.svg'


//modal
import PaymentModal from '../../components/Modals/payment';
import Payment from '../../components/Modals/paymentConfirmation';


//dummy data
import logo_cloud from '../../assets/img/AVAP_Cloud.svg'
import icon_cloud from '../../assets/img/logos/icono_Cloud.svg'
import icon_dev from '../../assets/img/logos/icono_DSs.svg'
import icon_api from '../../assets/img/logos/icon_APIControVersion.svg'
import icon_publisher from '../../assets/img/logos/icono_publisher.svg'
import icon_linter from '../../assets/img/logos/icon_avap.svg'
import profilePicture from '../../assets/img/placeholder/profile.jpeg'

import SessionService from '.././../services/SessionsService';
import ObexRequestHandler from '.././../handlers/ObexRequestsHandler';
import Cookies from 'universal-cookie';


//Dummy Data
const icons = {
    "icon_dev": icon_dev,
    "icon_api": icon_api,
    "icon_publisher": icon_publisher,
    "icon_linter": icon_linter,
};




import appsData from './appsData.json'
import commentsData from './comments.json'

const MarketplaceStoreDetailsReview = () => {


    // const apps = appsData.apps || [];
    const history = useHistory();


    // Obtener el parámetro `app` (ID de la app) desde la URL marca error- pero no es un error-
    const { app, version } = useParams();
    // Filtrar los datos de `apps` para obtener la app con ese ID
    // const appData = apps.find((application) => application.id === app);


    // Si no se encuentra la app, mostrar un mensaje
    // if (!appData) {
    //     return <div>App no encontrada</div>;

    // }


    const [APIS, setAPIS] = useState([]);
    const [APIProdToken, setAPIProdToken] = useState('Please sign up if you are a tester to see your token');

    //comentarios
    const [commentsData, setComments] = useState([]);
    const [commentsCount, setReviewsCount] = useState({ 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 });


    // Estado para manejar cuántos comentarios se muestran inicialmente
    const [visibleComments, setVisibleComments] = useState(8);

    // Estado para manejar la calificación seleccionada
    const [selectedRating, setSelectedRating] = useState(null);

    // Función para manejar el click de 'Ver más'
    const handleShowMore = () => {
        setVisibleComments((prevVisible) => prevVisible + 8);
    };

    // Función para manejar la selección de radio buttons
    const handleRatingChange = (rating) => {
        setSelectedRating(rating);  // Actualiza la calificación seleccionada
        setVisibleComments(8);  // Resetea los comentarios visibles a 8 cuando cambias el filtro
    };

    // Filtramos los comentarios según la calificación seleccionada 
    const filteredComments = selectedRating
        ? commentsData.filter(comment => Number(comment.rating) === selectedRating)
        : commentsData;

    // Solo mostramos los primeros 'visibleComments'
    const commentsToShow = filteredComments.slice(0, visibleComments);

    ///////////////////PaymentModal////////////////////////////////////////////////

    const [modalShow, setModalShow] = useState(false);

    ////////////////////////////////////////////////////////////////////
    // limitar los caracteres en el textarea de review. -modal-
    const [reviewText, setReviewText] = useState('');
    const [titleReviewText, setTitleReviewText] = useState('');
    const [scoreReview, setScoreReview] = useState(0);

    const maxChars = 240;

    // Función que maneja el cambio en el textarea
    const handleReviewChange = (event) => {
        const inputText = event.target.value;
        // Solo permite actualizar el texto si tiene menos de 240 caracteres
        if (inputText.length <= maxChars) {
            setReviewText(inputText);
        }
    };
    const handleTitleReviewChange = (event) => {
        const inputText = event.target.value;
        if (inputText.length <= 100) {
            setTitleReviewText(inputText);
        }
    };
    const handleStarsChange = (event) => {
        const inputText = event.target.value;
        setScoreReview(inputText)
    };

    const [appData, setAppData] = useState({
        api_product_id: 0,
        name: '',
        icon: '',
        devName: '',
        price: 0,
        overview: '',
        documentation: '',
        features: '',
        terms_of_use: '',
        tags: [],
        installations: 0,
        stars: 0,
        creation_date: '',
        last_modification_date: '',
        project_name: '',
        profilePicture: '',
        version: '',
        social_media: { 'linkedin': '', 'reddit': '', 'x': '' },
        status: '',
        price_period: '',
    });


    const [apps, setApps] = useState([]);

    const [get_personal_info, setGet_personal_info] = useState<any>({});
    const [isLoggedIn, setLogged] = useState(false);
    const [isPurchased, setPurchased] = useState(false);

    const [client, setClient] = useState(false);
    const [sessionExpired, setSessionExpired] = useState(false);
    const [inactivity, setInactivity] = useState(false);
    const cookies = new Cookies();


    const getPersonalInformation = async () => {
        try {
            // debugger
            const result = (await ObexRequestHandler.get('/get_personal_info')).data;
            // console.log("sidebar", result);
            setGet_personal_info(result);



        } catch (error) {
            console.error('ERROR FETCHING PERSONAL INFO ', error);
        }
    }

    const getAppData = async () => {
        try {
            const resulta = (await ObexRequestHandler.get(`/api_product_info?api_product_id=${app}&api_product_version=${version.replace(/\+/g, '.')}`));
            const result = resulta.data[0]
            result.creation_date = new Date(result.creation_date).toLocaleDateString();
            result.last_modification_date = new Date(result.last_modification_date).toLocaleDateString();

            const resulta2 = (await ObexRequestHandler.get(`/api_product_apis?api_product_id=${app}&api_product_version=${version.replace(/\+/g, '.')}`));
            for (let index = 0; index < resulta2.data.length; index++) {
                const element = resulta2.data[index];
                const avapapi = await getApiParameters(element.avapcatalog_api_project_id, element.avapcatalog_api_endpoint, element.ambient)
                resulta2['data'][index]['avapapi_parameters'] = avapapi.parameters;
                resulta2['data'][index]['avapapi_response'] = avapapi.response;
            }
            
            console.log('-------------X-------------');

            const filteredData = Object.values(
                resulta2.data.reduce((acc, item) => {
                  const catalogId = item.avap_catalog_id;
                  if (!acc[catalogId] || parseFloat(item.avapcatalog_api_version) > parseFloat(acc[catalogId].avapcatalog_api_version)) {
                    acc[catalogId] = item;
                  }
                  return acc;
                }, {})
              );


            console.log(filteredData);
            setAPIS(filteredData);
            
            console.log('-------------Y------------');
            result.tags = result.tags == null ? [] : result.tags
            setAppData(result);

            try {
                const resulta3 = (await ObexRequestHandler.get(`/apiproduct_token?api_product_id=${app}&version=${version.replace(/\+/g, '.')}`));
                console.log('------------', resulta3)
                /*setAPIProdToken(resulta3.data);*/
                resulta3.data==null?setAPIProdToken('Please sign up if you are a tester to see your token'):setAPIProdToken(resulta3.data);
            } catch (error) {
                console.log('Could not obtain the token')
            }


            // console.log("App Data: ", JSON.stringify(result, null, 2));

            // console.log(appData.price)

            getApps(result.user_id);
            getComments(result.api_product_id);
            getCountReviews(result.api_product_id);


        } catch (error) {
            console.error('ERROR FETCHING APP DATA ', error);
        }
    }
    const getApiParameters = async (obex_project_id, endpoint, ambient) => {
        try {

            try {
                const resulta3 = (await ObexRequestHandler.get(`/publishing/get_api_paremeters?obex_project_id=${obex_project_id}&endpoint=${endpoint}&ambient=${ambient}`));
                return resulta3.data

            } catch (error) {
                console.log('Could not obtain the token')
                return {}
            }



        } catch (error) {
            console.error('ERROR FETCHING APP DATA ', error);
        }
    }
    const getApps = async (_user_id) => {
        try {
            const result = (await ObexRequestHandler.get(`/api_product_list?user_id=${_user_id}`)).data;

            setApps(result);
            console.log(result);
        } catch (error) {
            console.error('ERROR FETCHING APPS ', error);
        }
    }
    const getComments = async (_api_product_id) => {
        try {
            const result = (await ObexRequestHandler.get(`/api_product_review?api_product_id=${_api_product_id}`)).data;
            setComments(result);

        } catch (error) {
            console.error('ERROR FETCHING COMMENTS ', error);
        }
    }

    const getCountReviews = async (_api_product_id) => {
        try {
            let commentCountdict = {};
            for (const [key, value] of Object.entries(commentsCount)) {
                const result = (await ObexRequestHandler.get(`/api_product_review?api_product_id=${_api_product_id}&stars=${key}`)).data;
                commentCountdict[key] = result.length
            }
            let commentCountdict2 = { ...commentsCount, ...commentCountdict }
            setReviewsCount(commentCountdict2);
        } catch (error) {
            console.error('ERROR FETCHING COMMENTS COUNTING ', error);
        }
    }

    const writeReview = async () => {
        try {
            let payload = {
                review: reviewText,
                score: scoreReview,
                title: titleReviewText,
                api_product_id: app
            };
            await ObexRequestHandler.post(`/api_product_review`, payload);
            getAppData();
        } catch (error) {
            console.error('ERROR WRITING COMMENT ', error);
        }
    }
    const registerInstallation = async () => {
        try {
            let payload = {

                api_product_id: app
            };
            await ObexRequestHandler.post(`/api_product_installation`, payload);
            getAppData();
        } catch (error) {
            console.error('ERROR REGISTERING INSTALL ', error);
        }
    }
    const buyAPIProduct = async () => {
        try {
            let payload = {

                api_product_id: app,
                version: version.replace(/\+/g, '.')
            };
            await ObexRequestHandler.post(`/buy_api_product`, payload);
            getAppData();
            checkAPIPurchasedState();
        } catch (error) {
            console.error('ERROR BUYING API PRODUCT', error);
        }
    }
    const checkAPIPurchasedState = async () => {
        try {

            const result = (await ObexRequestHandler.get(`/check_api_product_purchased?api_product_id=${app}`)).data;
            // console.log(result)
            setPurchased(result);
        } catch (error) {
            console.error('ERROR CHECKING API ', error);
        }
    }


    useEffect(() => {
        //API PRoduct requests
        //getPersonalInformation();
        getAppData();
        checkAPIPurchasedState();
        // getApps();
        // favicon
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);


        const user = cookies.get('101Obex');

        setClient(SessionService.Client);
        if (user) {
            if (performance.navigation.type == performance.navigation.TYPE_RELOAD) {
                SessionService.renewSession();
            }
            setLogged(true);
            getPersonalInformation();
        }
        if (!appData) {
            return () => { <div>App no encontrada</div>; }

        }
        // favicon
        return () => {
            document.head.removeChild(link);
            setAppData({
                api_product_id: 0, name: '', icon: '', devName: '', price: 0, overview: '', documentation: '', features: '', terms_of_use: '',
                tags: [], installations: 0, stars: 0, creation_date: '', last_modification_date: '', project_name: '', profilePicture: '', version: '',
                social_media: { 'linkedin': '', 'reddit': '', 'x': '' }, status: ''
            });

        };


    }, []);


    //modal triggers
    const [review, setReview] = useState(false);
    const [install, setInstall] = useState(false);

    const handleCloseReview = () => {
        writeReview();
        setReview(false)
    }
        ;
    const handleShowReview = () => setReview(true);

    const handleCloseInstall = () => setInstall(false);
    const handleShowInstall = () => {
        setModalShow(false); // Cierra el primer modal
        registerInstallation();
        buyAPIProduct();
        setInstall(true);
    }

    return (
        <>
            <NavbarMarket />

            <div id='mktDetails' className="w-100 bg-antiflash">
                <header className='container'>
                    <div className="row" id='headerInfo'>
                        <div className="col-12">
                            <div className="headerInfoWrapper">

                                <div className="infoContainer">
                                    <p className='titulo'>{appData.name}</p>
                                    <p className='devName'>{appData.devName}</p>


                                    <div className="buttonContainer mb-2">

                                        {/* {appData.type === 'Free' ? (
                                            <button className='btn-brick mr-3' onClick={handleShowInstall}>Install</button>
                                        ) : (
                                            <button className='btn-brick mr-3' onClick={handleShowInstall}>Buy</button>
                                        )} */}


                                        {/* Cambiar a este codigo para que se visualise si hay sesion inciada */}







                                        <p className='laberType'>{appData.price > 0 ? '$' + parseFloat(appData.price).toFixed(2) : 'FREE'}</p>
                                    </div>



                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12"> <hr className='margin-25' /> </div>
                    </div>

                    <div className="row" id='headerMenu'>

                        <div className="col-lg-4 col-md-3 col-sm-6 col-6  logo">
                            <Image src={logo_cloud} />
                        </div>
                        <div className="col-lg-2  col-md-3 col-sm-6 col-6   px-0"><p>Version {version.replace(/\+/g, '.')}</p></div>
                        <div className="col-lg-2  col-md-3 col-sm-6 col-6  px-0"><p><Image src={icon_descarga} className='iconDescargas' /> {appData.installations} installs</p></div>
                        <div className="col-lg-2  col-md-3 col-sm-6 col-6  px-0">
                            <p>
                                <div className="stars">
                                    {/* <FontAwesomeIcon icon={faStar} className="c-brick" size="1x" />
                                    <FontAwesomeIcon icon={faStar} className="c-brick" size="1x" />
                                    <FontAwesomeIcon icon={faStar} className="c-brick" size="1x" />
                                    <FontAwesomeIcon icon={faStar} className="c-brick" size="1x" />
                                    <FontAwesomeIcon icon={faStar} className="c-brick" size="1x" /> */}
                                    {Array.from({ length: 5 }, (v, i) => (
                                        <FontAwesomeIcon
                                            key={i}
                                            icon={faStar}
                                            className={i < appData.stars ? "c-brick" : "c-light-gray"}
                                            size="1x"
                                        />
                                    ))}
                                </div>

                                <span className='sideContent'> ({Math.floor(appData.stars * 100) / 100})</span>
                            </p>
                        </div>
                        <div className="col-lg-2 col-md-12 col-sm-12 px-0"><p>Category</p></div>
                    </div>
                </header>



                <div id='details' className="container-fluid mb-4">
                    <Tab.Container id="detailsTabs" defaultActiveKey="Overview" >
                        <Row className=''>
                            <div className="w-100 bg-white navShadow">
                                <Container id='tabsNavbar'>
                                    <Row>
                                        <Col sm={12}>
                                            <Nav className="flex detailsNav">
                                                <Nav.Item>
                                                    <Nav.Link eventKey="Overview">Overview</Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Nav.Link eventKey="Documentation">Documentation</Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Nav.Link eventKey="Developer">Developer</Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Nav.Link eventKey="Consumption">Consumption</Nav.Link>
                                                </Nav.Item>
                                            </Nav>
                                        </Col>
                                    </Row>
                                </Container>
                            </div>

                            <Container fluid id='tabsContent' >
                                <Row>
                                    <Col sm={12} className='p-0'>
                                        <Tab.Content>
                                            <Tab.Pane eventKey="Overview">
                                                <div className="container marginContent">
                                                    <div className="row">
                                                        <div className="col-md-9 ">
                                                            <div id="firstSection">
                                                                <p className='subtitulo'>AVAP Dev Extension</p>
                                                                <hr />
                                                                <p className='content'>
                                                                    {/* Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.
                                                                    Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis,
                                                                    uis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget,
                                                                    arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis
                                                                    pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi.
                                                                    <br /><br />
                                                                    Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim. Aliquam
                                                                    lorem ante, dapibus in, viverra quis. Curabitur ullamcorper ultricies nisi. Nam eget dui. Etiam rhoncus.
                                                                    Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero, sit amet adipiscing sem neque
                                                                    sed ipsum. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem. Maecenas nec odio et ante
                                                                    tincidunt tempus.
                                                                    <br /><br />
                                                                    Donec vitae sapien ut libero venenatis faucibus. Nullam quis ante. Etiam sit amet orci eget eros faucibus
                                                                    tincidunt. Duis leo. Sed fringilla mauris sit amet nibh. Donec sodales sagittis magna. Sed consequat, leo
                                                                    eget bibendum sodales, augue velit cursus.AVAP Dev Extension */}
                                                                    {
                                                                        appData.overview
                                                                    }
                                                                </p>
                                                            </div>

                                                            <div id="secondSection">
                                                                <p className='subtitulo'>Features</p>
                                                                <hr />
                                                                <p className='content'>
                                                                    {/* Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.
                                                                    Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis,
                                                                    uis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget,
                                                                    arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis
                                                                    pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi.
                                                                    <br /><br />
                                                                    Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim. Aliquam
                                                                    lorem ante, dapibus in, viverra quis. Curabitur ullamcorper ultricies nisi. Nam eget dui. Etiam rhoncus.
                                                                    Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero, sit amet adipiscing sem neque
                                                                    sed ipsum. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem. Maecenas nec odio et ante
                                                                    tincidunt tempus.
                                                                    <br /><br />
                                                                    Donec vitae sapien ut libero venenatis faucibus. Nullam quis ante. Etiam sit amet orci eget eros faucibus
                                                                    tincidunt. Duis leo. Sed fringilla mauris sit amet nibh. Donec sodales sagittis magna. Sed consequat, leo
                                                                    eget bibendum sodales, augue velit cursus.AVAP Dev Extension */}
                                                                    {appData.features}
                                                                </p>
                                                            </div>

                                                            <div id="thirdSection">
                                                                <p className='subtitulo'>Terms of use</p>
                                                                <hr />
                                                                <p className='content'>
                                                                    {/* Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.
                                                                    Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis,
                                                                    uis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget,
                                                                    arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis
                                                                    pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi.
                                                                    <br /><br />
                                                                    Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim. Aliquam
                                                                    lorem ante, dapibus in, viverra quis. Curabitur ullamcorper ultricies nisi. Nam eget dui. Etiam rhoncus.
                                                                    Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero, sit amet adipiscing sem neque
                                                                    sed ipsum. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem. Maecenas nec odio et ante
                                                                    tincidunt tempus.
                                                                    <br /><br />
                                                                    Donec vitae sapien ut libero venenatis faucibus. Nullam quis ante. Etiam sit amet orci eget eros faucibus
                                                                    tincidunt. Duis leo. Sed fringilla mauris sit amet nibh. Donec sodales sagittis magna. Sed consequat, leo
                                                                    eget bibendum sodales, augue velit cursus.AVAP Dev Extension */}
                                                                    {appData.terms_of_use}

                                                                </p>
                                                            </div>




                                                        </div>
                                                        <div className="col-md-3">
                                                            <div id="moreinfo" className='mb-5'>
                                                                <p className='subtitulo'>More Info</p>
                                                                <hr />
                                                                <p className='sideContent'>Relased on: <span>{appData.creation_date}</span></p>
                                                                <p className='sideContent'>Last Updated: <span>{appData.last_modification_date}</span> </p>
                                                                <p className='sideContent'>Publisher: <span> {appData.publisher}</span></p>
                                                                <p className='sideContent'>API Project: <span>{appData.project_name}</span></p>
                                                                <p className='sideContent'>APIs: <span>{appData.apis} APIs</span></p>
                                                            </div>

                                                            <div id="tags" className='mt-4'>
                                                                <p className='subtitulo'>Tags</p>
                                                                <hr />
                                                                <div className="tagsWrapper">
                                                                    {/* <a className='tag' href="">Keyword 01</a>
                                                                    <a className='tag' href="">Keyword</a>
                                                                    <a className='tag' href="">Key</a>
                                                                    <a className='tag' href="">Keyword</a> */}
                                                                    {

                                                                        appData.tags.map((item) => (
                                                                            <a className='tag' href="#">{item}</a>
                                                                        ))
                                                                    }
                                                                </div>
                                                            </div>

                                                            <div id="social" className='mt-4'>
                                                                <p className='subtitulo'>Social Links</p>
                                                                <hr />
                                                                <div className="socialWrapper">
                                                                    <a className='socialLink' href=""><FontAwesomeIcon icon={faLinkedin} /></a>
                                                                    <a className='socialLink' href=""><FontAwesomeIcon icon={faRedditSquare} /></a>
                                                                    <a className='socialLink' href="">

                                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                                                            <path d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm297.1 84L257.3 234.6 379.4 396H283.8L209 298.1 123.3 396H75.8l111-126.9L69.7 116h98l67.7 89.5L313.6 116h47.5zM323.3 367.6L153.4 142.9H125.1L296.9 367.6h26.3z" />
                                                                        </svg>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="Documentation">
                                                <div className="container marginContent">
                                                    <p className='subtitulo'>Documentation</p>
                                                    <hr />
                                                    <div
                                                        dangerouslySetInnerHTML={{ __html: appData.documentation }}
                                                    />
                                                    {/* <div className="row">
                                                        <div className="col-md-9 ">
                                                            <div id="firstSection">
                                                                
                                                                <p className='content'>
                                                                    
                                                              

                                                                </p>
                                                            </div>
                                                        </div>

                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-9">
                                                            <div id="secondSection">
                                                                <p className='subtitulo'>Titulo 01</p>
                                                                <hr />
                                                                <p className='content'>
                                                                    <ol className='customlist'>
                                                                        <li>
                                                                            Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis,
                                                                            uis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget,
                                                                            arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis
                                                                            pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi.
                                                                        </li>
                                                                        <li>
                                                                            Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim. Aliquam
                                                                            lorem ante, dapibus in, viverra quis. Curabitur ullamcorper ultricies nisi. Nam eget dui. Etiam rhoncus.
                                                                            Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero, sit amet adipiscing sem neque
                                                                            sed ipsum. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem. Maecenas nec odio et ante
                                                                            tincidunt tempus.
                                                                        </li>
                                                                        <li>
                                                                            Donec vitae sapien ut libero venenatis faucibus. Nullam quis ante. Etiam sit amet orci eget eros faucibus
                                                                            tincidunt. Duis leo. Sed fringilla mauris sit amet nibh. Donec sodales sagittis magna. Sed consequat, leo
                                                                            eget bibendum sodales, augue velit cursus.AVAP Dev Extension  Lorem ipsum dolor sit amet, consectetuer adipiscing elit.
                                                                            Aenean commodo ligula eget dolor. Aenean massa.
                                                                        </li>
                                                                    </ol>
                                                                </p>
                                                            </div>
                                                        </div>

                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-9">
                                                            <div id="thirdSection">
                                                                <p className='subtitulo'>Titulo 03</p>
                                                                <hr />
                                                                <p className='content'>
                                                                    Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.
                                                                    Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis,
                                                                    uis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget,
                                                                    arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis
                                                                    pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi.
                                                                    <br /><br />
                                                                    Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim. Aliquam
                                                                    lorem ante, dapibus in, viverra quis. Curabitur ullamcorper ultricies nisi. Nam eget dui. Etiam rhoncus.
                                                                    Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero, sit amet adipiscing sem neque
                                                                    sed ipsum. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem. Maecenas nec odio et ante
                                                                    tincidunt tempus.
                                                                    <br /><br />
                                                                    Donec vitae sapien ut libero venenatis faucibus. Nullam quis ante. Etiam sit amet orci eget eros faucibus
                                                                    tincidunt. Duis leo. Sed fringilla mauris sit amet nibh. Donec sodales sagittis magna. Sed consequat, leo
                                                                    eget bibendum sodales, augue velit cursus.AVAP Dev Extension
                                                                </p>
                                                            </div>

                                                        </div>

                                                        <div className="col-md-4"></div>
                                                    </div> */}

                                                </div>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="Developer">
                                                <div className="container marginContent">
                                                    <div className="row">
                                                        <div className="profileHeader">
                                                            <div id='#profilePicture' className='profilePicture' style={{ backgroundImage: `url(${atob(appData.profilePicture).toString()})` }}></div>
                                                            <div className="dataProfile">
                                                                <p className="name">
                                                                    {appData.user_name}
                                                                </p>
                                                                <p className="account">
                                                                    AVAP Cloud Business Account
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col">
                                                            <hr className='mt-3' />
                                                        </div>
                                                    </div>
                                                    <div className="row pt-5">
                                                        <div className="col-md-4">
                                                            <p className='profileDetails'>
                                                                <Image src={icon_mail} /> Mail: <span className='txt-regular'>{appData.devEmail}</span>
                                                            </p>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <p className='profileDetails'>
                                                                <Image src={icon_web} /> Website: <span className='txt-regular'>{appData.url}</span>
                                                            </p>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <p className='profileDetails'>
                                                                <Image src={icon_location} /> Country: <span className='txt-regular'>{appData.country}</span>
                                                            </p>
                                                        </div>
                                                    </div>

                                                    {/* <div className="row">
                                                        <div className="col">
                                                            <div className="messageContainer mt-3">
                                                                <p className="title">AVAP ID</p>
                                                                <hr className='w-100' />
                                                                <p className="message">La ficha de desarrollador, la puedes editar desde el perfil de AVAP ID raíz de este API Project.</p>
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                    <div className="row">
                                                        <div className="col">
                                                            <hr className='my-5' />
                                                        </div>
                                                    </div>
                                                    <div id='allApi' className="row">
                                                        <div className="col-12">
                                                            <p className='txt-20 txt-bold'>All API Products</p>
                                                        </div>
                                                        {apps.map((item) => (
                                                            <Col lg="2" md="3" sm="6" xs="6" className='px-custom'>

                                                                <a href={`/marketplaceStore/${item.api_product_id}/${item.version.replace('.', '+')}`} className="storeCard mb-3">
                                                                    <div className='icon'>
                                                                        <Image src={atob(item.icon).toString()} />
                                                                    </div>

                                                                    <div className="infoWrapper">
                                                                        <div className='title'>{item.name}</div>
                                                                        <div className="developerName">{item.devName}  </div>
                                                                        <div className='infoDw'>
                                                                            <div className="version">
                                                                                Version {item.version}
                                                                            </div>
                                                                            <div className="downloads">
                                                                                <Image src={icon_descarga} /> {item.installations}
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <hr className='mb-0 mt-3' />
                                                                    <div className="bottom">

                                                                        <div className="stars">
                                                                            <div className="iconWrapper">
                                                                                <Image src={icon_cloud} />
                                                                            </div>
                                                                            {Array.from({ length: 5 }, (v, i) => (
                                                                                <FontAwesomeIcon
                                                                                    key={i}
                                                                                    icon={faStar}
                                                                                    className={i < item.stars ? "c-brick" : "c-light-gray"}
                                                                                    size="1x"
                                                                                />
                                                                            ))}
                                                                        </div>
                                                                        <div className="type">
                                                                            {item.price == 0 ? 'FREE' :  '$' + parseFloat(item.price).toFixed(2)}
                                                                        </div>
                                                                    </div>

                                                                </a>
                                                            </Col>
                                                        ))}
                                                    </div>
                                                </div>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="Consumption">
                                                <div id='consumption' className="container marginContent">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <p className='title'>
                                                                <b>101ObexTesterToken:</b> {APIProdToken}
                                                            </p>
                                                            <p>
                                                            You can consume the APIs listed on the server at <b>http://avs-primary-pre.101obex.mooo.com</b> by including the header mentioned above.
                                                            </p>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="w-100  mb-2">
                                                    <div className="container h-100">
                                                        <div className="row h-100">
                                                            <div className="col-md-12">

                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div id='consumption' className="container marginContent">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <p className='title'>
                                                                APIs list
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="row"><div className="col"></div></div>
                                                </div>
                                                <div className="w-100  mb-2">
                                                    <div className="container h-100 buttonsWrapper">
                                                        <div className="row h-100">
                                                            <div className="col-md-12">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div id='reviews' className="container">
                                                    {/* Comentarios filtrados */}
                                                    {APIS.map((apis, index) => {
                                                        // Si el índice es par, abrimos una nueva fila (row)
                                                        if (true) {
                                                            return (
                                                                <div className="row reviewDivider" key={index}>
                                                                    {/* Primer comentario en la fila */}
                                                                    <div className="col-md-12">
                                                                        <div className="row reviewContainer">
                                                                            <div className="col reviewTop">
                                                                                <div className="reviewInfo">
                                                                                    <div className="profileHeader">

                                                                                        <div className="dataProfile">
                                                                                            <p className="name">{apis.avapcatalog_api_endpoint}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col reviewTop">
                                                                                <div className="reviewInfo">
                                                                                    <div className="profileHeader">

                                                                                        <div className="dataProfile">
                                                                                            <p > Parameters</p>
                                                                                            <ul style={{paddingLeft: "20px", fontSize: "small"}}>
                                                                                                {apis['avapapi_parameters'].map((param) => {
                                                                                                    return (<li>"{param}"</li>)
                                                                                                })}
                                                                                            </ul>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col reviewTop">
                                                                                <div className="reviewInfo">
                                                                                    <div className="profileHeader">

                                                                                        <div className="dataProfile">
                                                                                            <p >Response</p>
                                                                                            <ul style={{paddingLeft: "20px", fontSize: "small"}}>
                                                                                                {apis['avapapi_response'].map((response) => {
                                                                                                    return (<li>"{response}"</li>)

                                                                                                })}
                                                                                            </ul>

                                                                                        </div>

                                                                                    </div>
                                                                                </div>
                                                                            </div>                                                
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            );
                                                        }
                                                    })}
                                                </div>
                                            </Tab.Pane>
                                        </Tab.Content>
                                    </Col>

                                </Row>
                            </Container>
                        </Row>
                    </Tab.Container>
                </div >

                <FooterMenuAccess green={true} />


                {/* modal review */}

                <Modal show={review} onHide={handleCloseReview}>
                    <Modal.Header closeButton>
                        <Modal.Title>Add Review AVAP Dev Extension</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="reviewPopContainer">
                            <div className="popRateWrapper">
                                <Image src={atob(appData.icon).toString()} className='icon' />
                                <form>
                                    <fieldset className="ratingStarspop" onChange={handleStarsChange}>
                                        <input type="radio" id="star5" name="rating" value="5" />
                                        <label className="full" htmlFor="star5" title="5 stars"></label>

                                        <input type="radio" id="star4" name="rating" value="4" />
                                        <label className="full" htmlFor="star4" title="4 stars"></label>

                                        <input type="radio" id="star3" name="rating" value="3" />
                                        <label className="full" htmlFor="star3" title="3 stars"></label>

                                        <input type="radio" id="star2" name="rating" value="2" />
                                        <label className="full" htmlFor="star2" title=" 2 stars"></label>

                                        <input type="radio" id="star1" name="rating" value="1" />
                                        <label className="full" htmlFor="star1" title="1 star"></label>

                                    </fieldset>
                                </form>
                            </div>

                            <Form className='mt-4'>
                                <Form.Group controlId="exampleForm.ControlInput1">
                                    <Form.Label>Title</Form.Label>
                                    <Form.Control type="text" placeholder="Title" onChange={handleTitleReviewChange} value={titleReviewText} />
                                </Form.Group>
                                <Form.Control
                                    placeholder="Review (optional)"
                                    as="textarea"
                                    value={reviewText}
                                    onChange={handleReviewChange}
                                    rows={3}  // Ajusta la cantidad de filas que se mostrarán inicialmente
                                />
                                {/* Contador de caracteres */}
                                <div style={{ textAlign: 'right', marginTop: '5px' }}>
                                    {reviewText.length}/{maxChars}
                                </div>
                            </Form>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>

                        <button className='btn-brick' onClick={handleCloseReview}>
                            Add Review
                        </button>
                    </Modal.Footer>
                </Modal>


                {/* modal install */}

                <Modal show={install} onHide={handleCloseInstall}>
                    <Modal.Header closeButton>
                    </Modal.Header>
                    <Modal.Body>
                        <h1 className='customTitle'>Successfully added to your API Catalog.</h1>
                        <Image src={succesImage} className='d-block m-auto pt-5 pb-3' />
                        <p className='text-center mt-3'>AVAP Dev Extension is now available in your API Catalog of your AVAP Cloud deployment.</p>
                    </Modal.Body>
                    <Modal.Footer>

                        <button className='btn-brick' onClick={handleCloseInstall}>
                            Continue
                        </button>
                    </Modal.Footer>
                </Modal>

                <PaymentModal
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                    name={appData.name}
                    icon={appData.icon}
                    version={appData.version}
                    price={appData.price}
                    devName={appData.devName}
                    price_period={appData.price_period}
                    onContinue={handleShowInstall}
                    app={app}
                />


                {/* /// */}
                {/* <UpgradePlanModal
                    showModal={addingProjects && slotsInfo.availableSlots == 0 && possibleSlotsToBuy == 0}
                    text={'In order to add a new project you need to upgrade your plan. \n You have consumed the maximun slots available.'}
                    onCloseModal={whenClosing}
                    onCancelModal={whenClosing}
                    currentSuscription={currentSuscripcion}
                    onSuccess={whenClosing}
                /> */}

            </div >

        </>
    )
}

export default MarketplaceStoreDetailsReview;